import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";

export default function ComingSoon({ kicker, title, lede, items = [], primaryCta }) {
  return (
    <div data-testid="coming-soon-page">
      <section className="border-b border-[var(--eai-border)]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 lg:py-28">
          <p className="overline">{kicker}</p>
          <h1 className="mt-6 font-display text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight leading-[0.98] max-w-4xl">
            {title}
          </h1>
          <p className="mt-8 max-w-2xl text-lg text-[var(--eai-ink-2)] leading-relaxed">{lede}</p>
          <div className="mt-10 inline-flex items-center gap-3 border border-[var(--eai-border)] px-5 py-3" data-testid="coming-soon-badge">
            <Clock size={16} strokeWidth={1.6} className="text-[var(--eai-accent)]" />
            <span className="font-mono-eai text-xs uppercase tracking-[0.22em] text-[var(--eai-ink-2)]">In development — Coming soon</span>
          </div>
        </div>
      </section>

      {items.length > 0 && (
        <section className="border-b border-[var(--eai-border)]">
          <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 lg:py-24">
            <p className="overline">On the roadmap</p>
            <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[var(--eai-border)]">
              {items.map((it, i) => (
                <div key={it.title} className="bg-white p-8 lg:p-10 flex flex-col" data-testid={`roadmap-item-${i}`}>
                  <p className="font-mono-eai text-[11px] uppercase tracking-[0.22em] text-[var(--eai-accent)]">{String(i + 1).padStart(2, "0")} · {it.kind || "Planned"}</p>
                  <h3 className="mt-4 font-display text-2xl font-semibold tracking-tight leading-snug">{it.title}</h3>
                  <p className="mt-3 text-sm text-[var(--eai-ink-2)] leading-relaxed flex-1">{it.body}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      <section>
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20 lg:py-28 grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-8">
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.05]">
              In the meantime, read the live coverage.
            </h2>
            <p className="mt-6 text-[var(--eai-ink-2)] max-w-xl leading-relaxed">
              Our Intelligence Hub is publishing on the EU AI Act, the Digital Omnibus, enforcement architecture, and Ireland&rsquo;s positioning. New material every week.
            </p>
          </div>
          <div className="lg:col-span-4 lg:text-right flex lg:justify-end items-start">
            <Link to={primaryCta?.to || "/intelligence"} className="eai-btn" data-testid="coming-soon-primary-cta">
              {primaryCta?.label || "Read the Intelligence Hub"} <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
